import { useGetChartVolumeQuery } from "~/feature/chart/chartApi";
import type { IChartSelection } from "~/feature/chart/types";
import { buildChartRequest } from "~/feature/chart/utils";
import { useBackgroundError } from "~/hooks/useBackgroundError";

export const useChartVolume = (selection: IChartSelection) => {
  const { params, options } = buildChartRequest(selection);
  const { data, isUninitialized, isLoading, isFetching, error } =
    useGetChartVolumeQuery(params, options);

  useBackgroundError(error);

  return {
    volume: data ?? [],
    isVolumeLoading: (isUninitialized || isLoading || isFetching) && !data,
  };
};
